var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { AccordionSet, Accordion, Checkbox, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField, RecekSelection } from "./inputs";
import { ProductAccessibilityEnum, } from "../types/Api";
import { formatPublisherLabel } from "../utils/formatPublisherLabel";
import { getAccessibilityTranslation } from "../utils/getAccessibilityTranslation";
import { DateRangeFilterAccordions } from "./DateRangeFilterAccordions";
import { pickDateRangeFilters } from "../utils/dateRangeFilters";
export var ProductFilters = function (_a) {
    var filters = _a.filters, publishers = _a.publishers, publishersLoading = _a.publishersLoading, selectedPublisher = _a.selectedPublisher, onFilterChange = _a.onFilterChange, onAccessibilityChange = _a.onAccessibilityChange, onApplyFilters = _a.onApplyFilters, onPublisherInput = _a.onPublisherInput, hasUnappliedChanges = _a.hasUnappliedChanges, _b = _a.hasInvalidDateRange, hasInvalidDateRange = _b === void 0 ? false : _b, dateInputs = _a.dateInputs, _c = _a.showAccessibilityFilter, showAccessibilityFilter = _c === void 0 ? true : _c;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.filter.search",
                }), id: "product-search-filter", displayWhenClosed: React.createElement("div", null,
                    filters.id && (React.createElement("div", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.filter.folioId.accordion.label" }),
                        ": ",
                        filters.id)),
                    filters.productNumber && (React.createElement("div", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.product.filter.productNumber" }),
                        ": ",
                        filters.productNumber)),
                    filters.name && (React.createElement("div", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.product.filter.title" }),
                        ":",
                        " ",
                        filters.name)),
                    filters.contributor && (React.createElement("div", null,
                        React.createElement(FormattedMessage, { id: "ui-br-agency.product.filter.contributor" }),
                        ": ",
                        filters.contributor))) },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.product.filter.productNumber", placeholder: formatMessage({
                        id: "ui-br-agency.product.filter.productNumber.placeholder",
                    }), value: filters.productNumber, onChange: function (e) {
                        return onFilterChange("productNumber", e.target.value);
                    }, marginBottom0: true }),
                React.createElement(RecekTextField, { labelId: "ui-br-agency.filter.folioId.accordion.label", placeholder: formatMessage({
                        id: "ui-br-agency.product.filter.folioId.placeholder",
                    }), value: filters.id, onChange: function (e) {
                        return onFilterChange("id", e.target.value);
                    }, marginBottom0: true }),
                React.createElement(RecekTextField, { labelId: "ui-br-agency.product.filter.title", placeholder: formatMessage({
                        id: "ui-br-agency.product.filter.title.placeholder",
                    }), value: filters.name, onChange: function (e) {
                        return onFilterChange("name", e.target.value);
                    }, marginBottom0: true }),
                React.createElement(RecekTextField, { labelId: "ui-br-agency.product.filter.contributor", placeholder: formatMessage({
                        id: "ui-br-agency.product.filter.contributor.placeholder",
                    }), value: filters.contributor, onChange: function (e) {
                        return onFilterChange("contributor", e.target.value);
                    }, marginBottom0: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.filter.publisher",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.product.filter.publisher", showLabel: false, asyncFilter: true, value: selectedPublisher ? selectedPublisher.sourceId : "", loading: publishersLoading, onFilter: onPublisherInput, onChange: function (value) {
                        onFilterChange("publisherId", value);
                    }, dataOptions: __spreadArray(__spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-agency.collectionsList.select.option.all",
                            }),
                        }
                    ], (selectedPublisher &&
                        selectedPublisher.sourceId &&
                        selectedPublisher.name &&
                        !publishers.some(function (p) { return p.sourceId === selectedPublisher.sourceId; })
                        ? [
                            {
                                value: selectedPublisher.sourceId,
                                label: formatPublisherLabel(selectedPublisher, formatMessage),
                            },
                        ]
                        : []), true), publishers.map(function (publisher) { return ({
                        value: publisher.sourceId || "",
                        label: formatPublisherLabel(publisher, formatMessage),
                    }); }), true) })),
            showAccessibilityFilter && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.filter.accessibility",
                }), id: "product-accessibility-filter", displayWhenClosed: React.createElement("div", null, filters.accessibility.length > 0 && (React.createElement("div", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.product.filter.accessibility" }),
                    ":",
                    " ",
                    filters.accessibility
                        .map(function (accessibility) {
                        return getAccessibilityTranslation(intl, accessibility);
                    })
                        .join(", ")))) }, Object.values(ProductAccessibilityEnum).map(function (accessibility) { return (React.createElement(Checkbox, { key: accessibility, label: getAccessibilityTranslation(intl, accessibility), checked: filters.accessibility.includes(accessibility), onChange: function () { return onAccessibilityChange(accessibility); } })); }))),
            React.createElement(DateRangeFilterAccordions, { values: pickDateRangeFilters(filters), onChange: onFilterChange, invalidInputs: dateInputs.invalidInputs, onInvalidInputChange: dateInputs.setInputInvalid, inputsKey: dateInputs.inputsKey, labelIds: {
                    dateCreated: "ui-br-agency.product.filter.dateCreated",
                    dateUpdated: "ui-br-agency.product.filter.dateUpdated",
                }, idPrefix: "product-filter" })),
        React.createElement(Button, { type: "submit", buttonStyle: "primary", fullWidth: true, disabled: !hasUnappliedChanges || hasInvalidDateRange, marginBottom0: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.applyFilters" }))));
};
